function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { PlaybackType } from '../../core/player/playout-data';
import { checkIsSessionItemSleAutoplayType } from '../../utils/playback-type';
import { checkUnsupportedValue } from '../../utils/ts';
export function createVacFreewheelProvider(vmapProviderModule) {
    var FreewheelAdBreaksProvider = vmapProviderModule.FreewheelAdBreaksProvider, VacFreewheelUrlBuilder = vmapProviderModule.VacFreewheelUrlBuilder;
    return new FreewheelAdBreaksProvider(new VacFreewheelUrlBuilder());
}
export function createProviderFromAdInsertionConfig(multiPlayerCsaiConfig, vmapProviderModule, profileId) // @ts-ignore
{
    var FreewheelAdBreaksProvider = vmapProviderModule.FreewheelAdBreaksProvider, AdagioAdBreaksProvider = vmapProviderModule.AdagioAdBreaksProvider, StaticConfigFreewheelUrlBuilder = vmapProviderModule.StaticConfigFreewheelUrlBuilder;
    // TODO: change `adServer` type to an enum so that `as` inside each case can be removed.
    switch(multiPlayerCsaiConfig.profile.adServer){
        case 'freewheel':
            return new FreewheelAdBreaksProvider(new StaticConfigFreewheelUrlBuilder(_object_spread_props(_object_spread({}, multiPlayerCsaiConfig.server), {
                userId: profileId
            })));
        case 'adagio':
            return new AdagioAdBreaksProvider(multiPlayerCsaiConfig.server);
        default:
            checkUnsupportedValue(multiPlayerCsaiConfig.profile.adServer);
    }
}
export function shouldLoadAdvertisingAddons(sessionItem) {
    var _sessionItem_reporting;
    return !(((_sessionItem_reporting = sessionItem.reporting) === null || _sessionItem_reporting === void 0 ? void 0 : _sessionItem_reporting.isTrendingNow) || sessionItem.type === PlaybackType.Preview || checkIsSessionItemSleAutoplayType(sessionItem));
}

//# sourceMappingURL=ad-provider-selection.js.map